var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"modal-image-preview","scrollable":"","title":_vm.filename,"hide-footer":""}},[_c('form',{staticClass:"form-horizontal form-material"},[_c('img',{staticClass:"images-preview-modal img-responsive",attrs:{"src":_vm.url}}),_c('div',{staticClass:"img-caption"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }